import React from "react";
import { Judgement } from "../types";
import { formateDate } from "../hook/ScreenHelper";
import { COLORS } from "../constants";

const EJ_COLUMNS: {
  header: string;
  key: keyof Judgement;
}[] = [
  { header: "EJ_ENFORCE_DATE", key: "enforceDate" },
  { header: "EJ_RES_NUMBER", key: "resolutionNumber" },
  { header: "EJ_EXEC_TYPE", key: "executionType" },
  { header: "EJ_CITY", key: "city" },
  { header: "EJ_COURT_CODE", key: "courtCode" },
  { header: "EJ_CASE_NUMBER", key: "caseNumber" },
  { header: "EJ_DATE_LOADED", key: "loadedDate" },
  { header: "EJ_ORIG_CLAIM_AMT", key: "originalClaimAmount" },
];

interface JudgementsViewProps {
  data?: Judgement[];
}

const dateColumns: (keyof Judgement)[] = ["enforceDate", "loadedDate"];
const JudgementsView: React.FC<JudgementsViewProps> = ({ data = [] }) => {
  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      <p
        className="text-dark m-0"
        color={COLORS.TEXT_PRIMARY}
        style={{
          fontFamily: "Cairo",
          fontWeight: 500,
          fontSize: "20px",
          //   lineHeight: "135%",
          letterSpacing: "0",
        }}
      >
        Judgements
      </p>
      <table className="table text-center table-border spaced-table">
        {/* HEADER */}
        <thead style={{ background: COLORS.BG_LIGHTER }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            {EJ_COLUMNS.map((col) => (
              <th key={col.header}>{col.header}</th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {data.map((row, i) => (
            <tr key={row.caseNumber ?? i}>
              {EJ_COLUMNS.map((col) =>
                dateColumns.includes(col.key) ? (
                  <td key={col.header}>
                    {row[col.key] ? formateDate(row[col.key]) : "_"}
                  </td>
                ) : (
                  <td key={col.header}>{row[col.key] ?? "-"}</td>
                )
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default JudgementsView;
